// d2c直发下单金额限制
import { getD2cMoneyApi } from '@/apis/order'

export default {
  namespaced: true,
  state: {
    money: 0
  },
  getters: {
    getD2cMoney (state: { money: number }): number {
      return state.money
    }
  },
  mutations: {
    SET_D2C_MONEY: (
      state: { money: number },
      money: number
    ): void => {
      state.money = money
    }
  },
  actions: {
    getD2cMoney (store: any) {
      const { commit } = store
      getD2cMoneyApi({}).then((res: any) => {
        if (res.success) {
          commit('SET_D2C_MONEY', res.data)
        }
      })
    }
  }
}
